import { render, staticRenderFns } from "./SkuDetails.vue?vue&type=template&id=3ec5ccdf&scoped=true"
import script from "./SkuDetails.vue?vue&type=script&lang=js"
export * from "./SkuDetails.vue?vue&type=script&lang=js"
import style0 from "./SkuDetails.vue?vue&type=style&index=0&id=3ec5ccdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec5ccdf",
  null
  
)

export default component.exports